module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAABAklEQVQokXXRvyvEYRwH8NedL8NlUgabH5NQKORw/AM2KRuGK4PpRJlYTTdSStnULUrZLBTTDQyyiNWkkyj5Mdzn6kv5LM/T+/1+nuf9fj+ZYrEoNXuYxzcyKGO7QWb9nimMog1zmEiTyR/xEQ7wiD7s/ydewHLc2oEWrOK9cahhYwBbKOEc/XjACtYxnBZvRJAKZuOVaZxhE2tp8QyOY18JO6fBn0RwCdrxhtcge3GIC3yF5xrasxjCdSroIu6wi57AbjCYhLgaYCt20IxnPAVexUgWY7gMsIaCet95vAR+hXwWk+iKunJBlmPNqX9OJ8aT6LaAJXSjKWx84BP3uEXpB38dMjjsh554AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/ye.png
// module id = SRd4
// module chunks = 1